import * as React from 'react';
import { green, pink } from '@mui/material/colors';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import FolderIcon from '@mui/icons-material/Folder';
import PageviewIcon from '@mui/icons-material/Pageview';
import AssignmentIcon from '@mui/icons-material/Assignment';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Link as RouterLink } from 'react-router-dom';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import StackedBarChartIcon from '@mui/icons-material/StackedBarChart';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { Grid, Card, Paper } from '@mui/material';
import { useSelector } from 'react-redux';

export default function AssetButtons() {
  const appMode = useSelector((state) => state.mode.mode);
  return (
     
    <Grid container px={2} mt={1}  mb={2} rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
      <Grid item xs={3}>
      <Card sx={{borderRadius: '4px', paddingY: '5px'}}>
        <Box component={RouterLink}  to='/receive' sx={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', borderRadius: '50%',  textDecoration: 'none', color: 'inherit' }}>
          <Avatar src={appMode === 'dark' ? 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378459/withdraw_eqdznq-white_ghezrz.png' : 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378459/withdraw_eqdznq_hvup7h.png'} sx={{ padding: '5px', width: 40, height: 40}}>
            {/* <ArrowOutwardIcon /> */}
          </Avatar>  
          <Typography sx={{textAlign: 'center', fontSize: '12px'}}>Deposit</Typography>   
        </Box>
        </Card>
      </Grid>

      <Grid item xs={3}>
      <Card sx={{borderRadius: '4px', paddingY: '5px'}}>
        <Box component={RouterLink}  to='/send-coin' sx={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', borderRadius: '50%',  textDecoration: 'none', color: 'inherit' }}>
          <Avatar src={appMode === 'dark' ? 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378455/deposit_bvwyrg-white_bxe0j2.png' : 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378455/deposit_bvwyrg_yx8unu.png'} sx={{ padding: '5px', width: 40, height: 40}}>
            {/* <ArrowOutwardIcon /> */}
          </Avatar>  
          <Typography sx={{textAlign: 'center', fontSize: '12px'}}>Withdraw</Typography>   
        </Box>
        </Card>
      </Grid>

      <Grid item xs={3}>
      <Card sx={{borderRadius: '4px', paddingY: '5px'}}>
        <Box component={RouterLink}  to='/swap-coin' sx={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', borderRadius: '50%',  textDecoration: 'none', color: 'inherit' }}>
          <Avatar src={appMode === 'dark' ? 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378456/swap_vw5hqj-white_a1fumo.png' : 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378455/swap_vw5hqj_lnjjfj.png'} sx={{ padding: '5px', width: 40, height: 40}}>
            {/* <ArrowOutwardIcon /> */}
          </Avatar>  
          <Typography sx={{textAlign: 'center', fontSize: '12px'}}>Swap</Typography>   
        </Box>
        </Card>
      </Grid>

      <Grid item xs={3}>
      <Card sx={{borderRadius: '4px', paddingY: '5px'}}>
        <Box component={RouterLink}  to='/start-trading' sx={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', borderRadius: '50%',  textDecoration: 'none', color: 'inherit' }}>
          <Avatar src={appMode === 'dark' ? 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378459/candle_l9uey7-white_bkdamr.png' : 'https://res.cloudinary.com/dyz8kppso/image/upload/v1754378459/candle_l9uey7_b6819z.png'} sx={{ padding: '5px', width: 40, height: 40}}>
            {/* <ArrowOutwardIcon /> */}
          </Avatar>  
          <Typography sx={{textAlign: 'center', fontSize: '12px'}}>Trade</Typography>   
        </Box>
        </Card>
      </Grid>

    </Grid>
  );
}